module.exports = __webpack_public_path__ + "static/media/11x17no2.44d0668f.jpg";